'use es6';

import { pick, omit } from 'underscore';
import { FieldTypes } from 'ui-forms-components/constants/FieldTypeMapping';
import PropertyOption from 'FormsUI/lib/PropertyOption';
import { FieldTypesWithOptions } from 'forms-utils-lib/constants/Properties';
export const PropertyType = {
  STRING: 'string',
  ENUMERATION: 'enumeration',
  NUMBER: 'number',
  DATE: 'date',
  DATE_TIME: 'datetime'
};
const PropertyKeys = {
  DESCRIPTION: 'description',
  FIELD_TYPE: 'fieldType',
  FORM_FIELD: 'formField',
  GROUP_NAME: 'groupName',
  LABEL: 'label',
  NAME: 'name',
  TYPE: 'type',
  OPTIONS: 'options',
  SHOW_CURRENCY_SYMBOL: 'showCurrencySymbol',
  PROPERTY_OBJECT_TYPE: 'propertyObjectType'
};
const DEFAULT_PROPERTY = {
  [PropertyKeys.DESCRIPTION]: '',
  [PropertyKeys.FIELD_TYPE]: FieldTypes.TEXT,
  [PropertyKeys.FORM_FIELD]: true,
  [PropertyKeys.GROUP_NAME]: '',
  [PropertyKeys.LABEL]: '',
  [PropertyKeys.NAME]: '',
  [PropertyKeys.TYPE]: PropertyType.STRING,
  [PropertyKeys.OPTIONS]: []
};
function getPropertyType(PropertyFieldType) {
  switch (PropertyFieldType) {
    case FieldTypes.TEXT:
    case FieldTypes.TEXTAREA:
    case FieldTypes.FILE:
      return PropertyType.STRING;
    case FieldTypes.SELECT:
    case FieldTypes.RADIO:
    case FieldTypes.CHECKBOX:
    case FieldTypes.SINGLE_CHECKBOX:
      return PropertyType.ENUMERATION;
    case FieldTypes.NUMBER:
      return PropertyType.NUMBER;
    case FieldTypes.DATE:
      return PropertyType.DATE;
    default:
      return PropertyType.STRING;
  }
}
function getDefaultBooleanCheckboxOptions() {
  return [new PropertyOption({
    label: 'Yes',
    value: true
  }), new PropertyOption({
    label: 'No',
    value: false
  })];
}
function updateRelevantProperties(property) {
  const {
    fieldType
  } = property;
  let updatedProperty = property;
  if (fieldType !== FieldTypes.NUMBER) {
    updatedProperty = omit(updatedProperty, 'showCurrencySymbol');
  }
  if (fieldType === FieldTypes.SINGLE_CHECKBOX) {
    updatedProperty = Object.assign({}, updatedProperty, {
      options: getDefaultBooleanCheckboxOptions()
    });
  } else if (!Object.prototype.hasOwnProperty.call(FieldTypesWithOptions, fieldType)) {
    updatedProperty = Object.assign({}, updatedProperty, {
      options: []
    });
  }
  return updatedProperty;
}
export default class Property {
  constructor(data) {
    const property = pick(data, Object.values(PropertyKeys || {}));
    const propertyModified = {
      type: getPropertyType(property.fieldType)
    };
    return Object.assign({}, DEFAULT_PROPERTY, updateRelevantProperties(property), propertyModified);
  }
}